
import { i18nText } from '@/locales';

    import { Component, Vue, Watch } from "vue-property-decorator";
    import { mixins } from "vue-class-component";
    import FormGroup from "@/UI/components/common/form/FormGroup.vue";
    import PageTitle from "@/UI/components/common/PageTitle.vue";
    import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
    import { Button, Col, FormModel, Input, List, Menu, Row, Select, Table, Tabs } from "ant-design-vue";
    import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
    import { VisitSupportMix } from "@/UI/pages/visitsNew/mixins/Support";
    import { showNotificationSimple } from "@/UI/lib/messages";
    import { VisitsStore } from "@/store/modules/Visits";
    import { AppStateStore } from "@/store/modules/appState";
    import { ProductsDataForm } from "@/form/visits/New/Products";
    import { StoresStore } from "@/store/modules/Warehouse/Warehouse";
    import { getStudioId } from "@/UI/lib/state";
    import { StoreMix } from "@/UI/mixins/Store/StoreMix";
    import { ProductsStockStore } from "@/store/modules/Warehouse/ProductsStock";
    import { ProductsStock } from "@/entity/warehouse/Products/ProductsStock.types";

    @Component({
        components: {
            FormGroup,
            PageTitle,
            BaseDataForm,
            "a-button": Button,
            "a-menu-item": Menu.Item,
            "a-list-item": List.Item,
            "a-list-item-meta": List.Item.Meta,
            "a-select": Select,
            "a-select-option": Select.Option,
            "a-table": Table,
            "a-input": Input,
            "a-tab": Tabs,
            "a-tab-pane": Tabs.TabPane,
            "a-form-model": FormModel,
            "a-form-model-item": FormModel.Item,
            "a-row": Row,
            "a-col": Col,
        },
    })
    export default class VisitProducts extends mixins(VisitSupportMix,SimpleProxyForm, StoreMix) {
        productsForm = new ProductsDataForm();
        sData = this.$store;
        stockProducts = this.sData.state["productsStock"]["items"];
        renderCount = 0;
        renderSelect = false;

        async changeSourceProduct(store_id: any): Promise<void> {
            await this.getStoreProducts(store_id);
        }
        async getStoreProducts(store_id: number): Promise<void> {
            try {
                await ProductsStockStore.fetchAll({
                    filter: { store_id: store_id },
                });
            } catch (e) {
                showNotificationSimple(i18nText("Ошибка получения данных с склада"), e, 100);
            }
        }

        stockProductsData(): any {
            if (this.stockProducts["data"]) {
                this.renderSelect = true;
                return this.stockProducts["data"];
            } else {
                this.renderSelect = true;

                return null;
            }
        }

        getStockProducts = async (store_id: number): Promise<{ items: ProductsStock | null; itemsLoaded: boolean }> => {
            return await ProductsStockStore.fetchAll({
                filter: { store_id: store_id },
            });
        };

        async changeStore(store_id: any): Promise<void> {
            this.renderSelect = false;
            await this.getStoreProducts(store_id);
        }

        async getData(): Promise<void> {
            try {
                this.formReady = false;

                await VisitsStore.fetchData({ filter: { id: Number(Vue.router.currentRoute.params["id"]) } });
                await VisitsStore.fetchVisitProducts(Number(Vue.router.currentRoute.params["id"]));
                await StoresStore.fetchAll({ filter: { salon_id: getStudioId(this) } });

                // await this.form.parseVisitData(this.visit); ошибка типа пока закоментировал
                await this.productsForm.assignProducts(this.$store.state["visits"]["products"]);
            } catch (e) {
                showNotificationSimple(i18nText("Ошибка получения данных"), e, 100);
            } finally {
                this.formReady = true;
            }
        }

        async StoreProductsData(): Promise<void> {


          await VisitsStore.saveVisitProducts({
                visit_id: Number(Vue.router.currentRoute.params["id"]),
                product_list: this.productsForm.productsData,
            }).then(async (response) => {
                if (response["status"]) {
                    showNotificationSimple(i18nText(" Успешное сохранение расходников-"), response.response, 10);
                }
            });
        }

        @Watch("$store.state.appState.sendDelete", { immediate: false })
        async ButtonDelete(): Promise<void> {
            AppStateStore.setDelete(false);
            //await this.deleteVisit(this.form);
        }

        @Watch("$store.state.appState.sendSubmit", { immediate: false })
        async ButtonSubmit(value: boolean): Promise<void> {
            AppStateStore.setUpdate(false);
            await this.StoreProductsData();

            //await this.updateVisit(value, this.form, this.RecordParams);
        }
        @Watch("$store.state.appState.sendCancel", { immediate: false })
        async ButtonCancel(value: boolean): Promise<void> {
            AppStateStore.setCancel(false);
            // await this.pushToCalendar(this.form!, this.RecordParams) ошибка типа пока закоментировал
        }

        async created(): Promise<void> {
            try {
                await this.getData();
            } catch (e) {
                showNotificationSimple(i18nText("Ошибка получения данных"), e, 100);
            } finally {
                this.formReady = true;
            }
        }
    }
